module.exports = __webpack_public_path__ + "static/media/1029613.16a8f76b.jpg";